export default {
  namespaced: true,
  state () {
    return {
      problem_ids: [],
      detail: null,
      shipment_num: null
    }
  },
  getters: {
    problem_ids (state) {
      return state.problem_ids
    },
    detail (state) {
      return state.detail
    },
    shipment_num (state) {
      return state.shipment_num
    }
  },
  mutations: {
    setProblemIds (state, ids) {
      state.problem_ids = ids
    },
    setDetail (state, detail) {
      state.detail = detail
    },
    addProblemField (state, fieldName) {
      state.detail.have_problem_fields.push(fieldName)
    },
    setShipmentNum (state, num) {
      state.shipment_num = num
    }
  },
  actions: {
    setProblemIds ({commit}, ids) {
      commit('setProblemIds', ids)
    },
    setDetail ({commit}, detail) {
      commit('setDetail', detail)
    },
    addProblemField ({commit}, fieldName) {
      commit('addProblemField', fieldName)
    },
    setShipmentNum ({commit}, num) {
      commit('setShipmentNum', num)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Repack/store.js